import { render, staticRenderFns } from "./DefinitionTerm.vue?vue&type=template&id=cc56537e&scoped=true&"
import script from "./DefinitionTerm.vue?vue&type=script&lang=ts&"
export * from "./DefinitionTerm.vue?vue&type=script&lang=ts&"
import style0 from "./DefinitionTerm.vue?vue&type=style&index=0&id=cc56537e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc56537e",
  null
  
)

export default component.exports